<template>
    <l-marker
        :visible="truck.visible && truck.visible_on_map"
        :lat-lng="[truck.lastpoint.lat, truck.lastpoint.lng]"
        @click="$emit('click', truck)"
    >
        <!-- REFACTOR-020 follow-up (Sprint 12): :key sull'icona (non sul marker).
             Dopo il passaggio a :key="truck.id" sul marker (no re-mount), LIcon di
             vue2-leaflet aggiorna il DivIcon via MutationObserver SOLO se il marker è
             renderizzato (getElement() != null) → un marker dentro un cluster non
             riceve l'HTML-swap e mostra colore/stato STALE quando ricompare.
             Keyando l'icona sulla signature visiva DISCRETA (colore/glifo/stato/alert/
             gancio) forziamo la ricreazione del solo DivIcon al cambio stato — anche se
             clusterizzato — senza ricreare il layer Leaflet né ri-clusterizzare (il
             guadagno resta). La heading (continua) NON è nella key: nessun churn, è
             gestita dal MutationObserver per i marker visibili. -->
        <l-icon :key="iconRenderKey" :icon-anchor="anchorSize" :icon-size="iconSize" class-name="position-relative">
            <svg
                :class="{ bounce: bounce, focused: truck.on_focus }"
                id="Goccia"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-19 -3 159.5 190.4"
            >
                <path
                    id="Traccia_goccia"
                    data-name="Traccia goccia"
                    d="M164,84.8c0,33-59.7,109.2-59.7,109.2S44.5,117.8,44.5,84.8a59.8,59.8,0,0,1,119.5,0Z"
                    transform="translate(-44.5 -12.6)"
                    fill="#fff"
                />
                <path
                    id="Base_goccia"
                    data-name="Base goccia"
                    d="M157.4,87.6c0,29.3-53.1,97-53.1,97s-53.1-67.7-53.1-97a53.1,53.1,0,0,1,106.2,0Z"
                    transform="translate(-44.5 -12.6)"
                    :fill="iconBackgroundColor"
                    style="filter: brightness(1.2)"
                />
                <path
                    id="Mezza_goccia_riflesso"
                    data-name="Mezza goccia riflesso"
                    d="M157.4,87.6a53.1,53.1,0,0,0-53.1-53.1V184.6S157.4,116.9,157.4,87.6Z"
                    transform="translate(-44.5 -12.6)"
                    :fill="iconBackgroundColor"
                    style="filter: brightness(0.9)"
                />
                <g
                    class="rotate"
                    fill="div-rotate"
                    :style="{
                        transform: direction,
                        'transform-origin': '37.7% 39%',
                        '-webkit-transform-Origin': '37.7% 39%',
                        '-moz-transform-Origin': '37.7% 39%',
                        '-ms-transform-Origin': '37.7% 39%',
                        '-o-transform-Origin': '37.7% 39%'
                    }"
                >
                    <path
                        v-if="vehicleAlertsList.length > 0"
                        id="Freccia_direzionale"
                        data-name="Freccia direzionale"
                        d="M150.1,86.4a45.9,45.9,0,0,0-30.2-43.1L104.3,12.6,88.7,43.3a45.8,45.8,0,1,0,61.4,43.1Z"
                        transform="translate(-44.5 -12.6)"
                        fill="var(--danger)"
                    />
                    <path
                        v-else
                        id="Freccia_direzionale"
                        data-name="Freccia direzionale"
                        d="M150.1,86.4a45.9,45.9,0,0,0-30.2-43.1L104.3,12.6,88.7,43.3a45.8,45.8,0,1,0,61.4,43.1Z"
                        transform="translate(-44.5 -12.6)"
                        :fill="iconBackgroundColor"
                        style="filter: brightness(0.6)"
                        :class="vehicle_status"
                    />
                </g>
                <text
                    v-if="vehicleAlertsList.length > 0"
                    x="35"
                    y="90"
                    style="font-family: 'Font Awesome Kit', 'FontAwesome'; font-size: 52px"
                    fill="#fff"
                    v-html="'&#xF071;'"
                ></text>
                <text
                    v-else
                    :x="iconPosition.x"
                    :y="iconPosition.y"
                    style="
                        font-family: 'Font Awesome Kit', 'FontAwesome', 'Font Awesome 6 Pro';
                        font-size: 50px;
                    "
                    fill="#fff"
                    v-html="iconType"
                ></text>
            </svg>
            <div
                class="plate d-flex flex-column flex-wrap"
                :class="{ focused: truck.on_focus }"
                :style="
                    storedVehicleMarkerFontColor
                        ? '--text-color: ' + storedVehicleMarkerFontColor
                        : ''
                "
            >
                <span
                    :style="markerStyle"
                    :class="{ 'with-additional-data': hasAdditionalData }"
                    v-if="storedVehicleIdentification && storedCopyIdentificationToMarker"
                >
                    {{ identification | truncate(this.$env.PLATE_TRUNCATE_LENGTH) }}
                    <i class="font-awesome" v-if="isTruckHookedComputed"> &#xe1cb; </i>
                </span>
                <span
                    :style="markerStyle"
                    :class="{ 'with-additional-data': hasAdditionalData }"
                    v-else
                >
                    {{
                        (truck.details.custom_id || truck.plate)
                            | truncate(this.$env.PLATE_TRUNCATE_LENGTH)
                    }}
                    <i class="font-awesome" v-if="isTruckHookedComputed"> &#xe1cb; </i>
                </span>

                <span
                    v-for="(item, i) in vehicleAdditionalDataItems"
                    :key="item.key"
                    class="additional-data-row"
                    :class="{ 'is-last': i === vehicleAdditionalDataItems.length - 1 }"
                    :style="item.style"
                    >{{ item.text }}
                </span>
            </div>
        </l-icon>
    </l-marker>
</template>

<script>
import { toRefs } from 'vue'
import { LMarker, LIcon } from 'vue2-leaflet'
import { useVehicleStatus } from '@/composables/useVehicleStatus'
import { useVehicleAlerts } from '@/composables/useVehicleAlerts'
import { useVehicleIdentification } from '@/composables/useVehicleIdentification'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'LTruckMarker',
    props: ['truck'],
    setup(props) {
        const { truck } = toRefs(props)
        const { vehicle_status, vehicle_color_var } = useVehicleStatus(truck)
        const { alerts } = useVehicleAlerts(truck)
        // REFACTOR-001 (Sprint 8): identificativo veicolo dal composable condiviso
        // invece del computed inline duplicato (allineato a DetailsHead/TruckListItem).
        const { identification } = useVehicleIdentification(truck)

        return {
            vehicle_status,
            vehicle_color_var,
            alerts,
            identification
        }
    },
    components: {
        LMarker,
        LIcon
    },
    data() {
        return {
            bounce: false
        }
    },
    watch: {
        'truck.lastpoint': function (lastpoint) {
            if (this.bounce) this.bounce = false

            if (this.truck.on_focus) this.$emit('moving', lastpoint.lat, lastpoint.lng)
        },
        'truck.on_focus': function (active) {
            this.bounce = !!active
        }
    },
    methods: {
        // Testo mostrato per un singolo dato aggiuntivo. Ritorna null quando il
        // valore non è disponibile sul mezzo, così la voce non viene renderizzata.
        additionalDataText(value) {
            const lastpoint = this.truck?.lastpoint || {}

            switch (value) {
                case 'speed': {
                    const speed = lastpoint.tacho_speed || lastpoint.speed
                    return speed != null ? speed + ' Km/h' : null
                }
                case 'altitude':
                    return lastpoint.altitude != null ? lastpoint.altitude + ' m.s.l.m' : null
                case 'rpm_engine': {
                    // Real telemetry uses `engine_rpm`; the preview dummy data uses
                    // `rpm_engine`, so fall back to it.
                    const rpm = lastpoint.engine_rpm ?? lastpoint.rpm_engine
                    return rpm != null ? rpm + ' RPM' : null
                }
                case 'driver_full_name': {
                    const driver = lastpoint.driver || lastpoint.last_driver
                    const fullName = [driver?.name, driver?.surname].filter(Boolean).join(' ').trim()
                    return fullName || null
                }
                case 'custom_code':
                    return this.truck?.details?.custom_id || null
                default:
                    return null
            }
        },
        // Converte un colore esadecimale (#rrggbb) nel triplet "r, g, b" usato
        // dalle CSS var --bg-color (consumate via rgba()). Null se non valido.
        hexToRgb(hex) {
            if (!hex || hex.length < 7) return null
            const r = parseInt(hex.substring(1, 3), 16)
            const g = parseInt(hex.substring(3, 5), 16)
            const b = parseInt(hex.substring(5, 7), 16)
            return `${r}, ${g}, ${b}`
        },
        // Stile per-voce: sfondo/colore testo/opacità presi dalla configurazione
        // della singola voce. I campi assenti ricadono sui default CSS del marker.
        additionalItemStyle(item) {
            let style = ''

            const bg = this.hexToRgb(item.backgroundColor)
            if (bg) style += '--bg-color: ' + bg + ';'

            if (item.fontOpacity != null && item.fontOpacity !== '')
                style += '--opacity: ' + (100 - Number(item.fontOpacity)) / 100 + ';'

            if (item.fontColor) style += '--text-color: ' + item.fontColor + ';'

            return style
        }
    },
    computed: {
        iconType() {
            if (!this.storedCopyIconTypeToMarker) {
                return this.truck.category && this.truck.category.fa
                    ? JSON.parse(this.truck.category.fa).unicode
                    : '&#xe00d;'
            }

            if (
                !this.storedIconType ||
                (this.storedIconType && this.storedIconType.value == 'truck')
            )
                return this.truck.category && this.truck.category.fa
                    ? JSON.parse(this.truck.category.fa).unicode
                    : '&#xe00d;'
            else {
                if (this.truck?.lastpoint?.activity == 0) return '&#xf236;'
                if (this.truck?.lastpoint?.activity == 1) return '&#xe014;'
                if (this.truck?.lastpoint?.activity == 2) return '&#xe013;'
                if (this.truck?.lastpoint?.activity == 3) return '&#xf622;'
                return '&#xf4fa;'
            }
        },
        iconBackgroundColor() {
            if (!this.storedCopyIconColorToMarker) {
                return this.vehicle_color_var
            }

            if (
                !this.storedIconColor ||
                (this.storedIconColor && this.storedIconColor.value == 'truck_status')
            )
                return this.vehicle_color_var
            else if (this.storedIconColor && this.storedIconColor.value == 'driver_activity') {
                if (this.truck?.lastpoint?.activity == 0) return 'var(--rest-color)'
                if (this.truck?.lastpoint?.activity == 1) return 'var(--availability-color)'
                if (this.truck?.lastpoint?.activity == 2) return 'var(--work-color)'
                if (this.truck?.lastpoint?.activity == 3) return 'var(--driving-color)'
                return 'var(--default-color)'
            } else if (this.storedIconColor && this.storedIconColor.value == 'driver_status') {
                if (this.truck?.lastpoint?.driver?.state?.id) {
                    let id = this.truck?.lastpoint?.driver?.state?.id
                    if (!this.storedDriversStatusColors) return 'var(--default-color)'
                    else return this.storedDriversStatusColors[id]
                }
                return 'var(--default-color)'
            } else return 'var(--main-text-color)'
        },
        iconSize() {
            let markerSize = this.storedVehicleMarkerSize || [52, 66]
            return markerSize
        },
        iconPosition() {
            let x = 28
            let y = 92

            if (this.storedIconType && this.storedIconType.value == 'driver_activity') {
                if (this.truck?.lastpoint?.activity == 3) x = 34
            }

            return {
                x: x,
                y: y
            }
        },
        anchorSize() {
            let markerSize = this.storedVehicleMarkerSize || [52, 66]
            return [markerSize[0] / 2, markerSize[1]]
        },
        markerStyle() {
            let style = ''

            if (this.storedVehicleMarkerFontSize)
                style += '--text-size: ' + this.storedVehicleMarkerFontSize + ';'

            if (this.storedVehicleMarkerBackgroundColor)
                style += '--bg-color: ' + this.vehicleMarkerBackgroundColor.rgb + ';'

            // this.storedVehicleMarkerOpacity comes with a value from 0 to 100 and consists to the negative value of the opacity
            if (this.storedVehicleMarkerOpacity)
                style += '--opacity: ' + (100 - this.storedVehicleMarkerOpacity) / 100 + ';'

            return style
        },
        // Builds the list of additional-data rows rendered under the plate.
        // Each config entry (`{ value, label, backgroundColor, fontColor,
        // fontOpacity }`) becomes `{ key, text, style }`. Back-compatible with the
        // old single-string format and with arrays of strings.
        vehicleAdditionalDataItems() {
            const raw = this.storedVehicleMarkerAdditionalData
            const items = Array.isArray(raw) ? raw : raw ? [raw] : []

            return items
                .map((item) => {
                    // Legacy entries are a bare value string; current entries are objects.
                    const isLegacy = typeof item === 'string'
                    const value = isLegacy ? item : item.value
                    const text = this.additionalDataText(value)
                    // Skip entries with no value available (field missing on the vehicle).
                    if (text == null || text === '') return null
                    // Legacy entries pull their style from the old per-config color keys
                    // so the marker looks identical after migration.
                    const style = isLegacy
                        ? {
                              backgroundColor: this.storedVehicleAdditionalInfoBackgroundColor,
                              fontColor: this.storedVehicleAdditionalInfoFontColor,
                              fontOpacity: this.storedVehicleAdditionalInfoOpacity
                          }
                        : item
                    return { key: value, text, style: this.additionalItemStyle(style) }
                })
                .filter(Boolean)
        },
        hasAdditionalData() {
            return this.vehicleAdditionalDataItems.length > 0
        },
        vehicleMarkerBackgroundColor() {
            if (!this.storedVehicleMarkerBackgroundColor) return null

            let color = this.storedVehicleMarkerBackgroundColor
            let r = parseInt(color.substring(1, 3), 16)
            let g = parseInt(color.substring(3, 5), 16)
            let b = parseInt(color.substring(5, 7), 16)

            return {
                hex: color,
                rgb: `${r}, ${g}, ${b}`
            }
        },
        truckSpeed() {
            return this.truck.lastpoint.tacho_speed || this.truck.lastpoint.speed
        },
        vehicleAlertsList() {
            return Object.values(this.alerts) || []
        },
        direction() {
            return `rotate(${this.truck.lastpoint.heading}deg)`
        },
        // REFACTOR-020 follow-up (Sprint 12): signature visiva DISCRETA dell'icona.
        // Cambia solo a una transizione di stato reale (colore goccia, glifo, classe
        // stato, presenza alert, gancio) — NON ad ogni poll/heading → l'icona si ricrea
        // di rado. Usata come :key sull'<l-icon> per garantire il refresh del DivIcon
        // anche per i marker clusterizzati (vedi commento nel template).
        iconRenderKey() {
            return [
                this.iconBackgroundColor,
                this.iconType,
                this.vehicle_status,
                this.vehicleAlertsList.length,
                this.isTruckHookedComputed,
                this.additionalDataConfigKey
            ].join('|')
        },
        // Signature DISCRETA della sola CONFIGURAZIONE dei dati aggiuntivi (voci,
        // ordine, colori/opacità) — NON dei valori live (velocità ecc.). Cambia solo
        // quando l'utente modifica le impostazioni, così il DivIcon si rigenera (anche
        // per i marker clusterizzati) senza ricrearsi ad ogni poll. Computed cachata:
        // il JSON.stringify rigira solo quando cambia il riferimento del config.
        additionalDataConfigKey() {
            const raw = this.storedVehicleMarkerAdditionalData
            return Array.isArray(raw) ? JSON.stringify(raw) : raw || ''
        },
        ...mapState({
            // Sprint 19 (hot-render ×660): sotto-chiavi NUDE al posto del blob intero, a
            // PARITÀ ESATTA col legacy (assente → undefined: i truthy-check inline NON
            // applicano stili/branch — i default schema qui non sono load-bearing, vedi
            // decision Sprint 19). Niente `value(key)`: il clone-per-lettura dei default
            // reference creerebbe identità instabili su un path renderizzato per-marker.
            storedVehicleMarkerFontColor: (state) => state.config.user.vehicleMarkerFontColor,
            storedVehicleIdentification: (state) => state.config.user.vehicleIdentification,
            storedCopyIdentificationToMarker: (state) =>
                state.config.user.copyIdentificationToMarker,
            storedCopyIconTypeToMarker: (state) => state.config.user.copyIconTypeToMarker,
            storedIconType: (state) => state.config.user.iconType,
            storedIconColor: (state) => state.config.user.iconColor,
            storedCopyIconColorToMarker: (state) => state.config.user.copyIconColorToMarker,
            storedDriversStatusColors: (state) => state.config.user.driversStatusColors,
            storedVehicleMarkerSize: (state) => state.config.user.vehicleMarkerSize,
            storedVehicleMarkerFontSize: (state) => state.config.user.vehicleMarkerFontSize,
            storedVehicleMarkerBackgroundColor: (state) =>
                state.config.user.vehicleMarkerBackgroundColor,
            storedVehicleMarkerOpacity: (state) => state.config.user.vehicleMarkerOpacity,
            storedVehicleMarkerAdditionalData: (state) =>
                state.config.user.vehicleMarkerAdditionalData,
            // Chiavi di stile del VECCHIO formato (dato aggiuntivo singolo): servono
            // solo a preservare i colori quando si migra una config legacy a stringa.
            storedVehicleAdditionalInfoBackgroundColor: (state) =>
                state.config.user.vehicleAdditionalInfoBackgroundColor,
            storedVehicleAdditionalInfoFontColor: (state) =>
                state.config.user.vehicleAdditionalInfoFontColor,
            storedVehicleAdditionalInfoOpacity: (state) =>
                state.config.user.vehicleAdditionalInfoOpacity,
            truck_hooked_list: (state) => state.geoFleet.truck_hooked_list
        }),
        isTruckHookedComputed() {
            // Force reactivity by explicitly depending on truck_hooked_list
            return this.truck_hooked_list.some(
                (e) => e.truck === this.truck.plate || e.trailer === this.truck.plate
            )
        }
    }
}
</script>

<style scoped>
.bounce {
    animation: bounce 2.5s ease 1;
}
@keyframes bounce {
    0%,
    15%,
    35%,
    55%,
    75%,
    100% {
        transform: translateY(0);
    }
    10% {
        transform: translateY(-25px);
    }
    30% {
        transform: translateY(-25px);
    }
    50% {
        transform: translateY(-25px);
    }
    70% {
        transform: translateY(-25px);
    }
    90% {
        transform: translateY(-25px);
    }
}
.plate {
    --text-color: var(--main-text-color);
    display: flex;
    justify-content: center;
    font-size: 0.7rem;
    color: var(--text-color);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}
.plate span {
    --text-size: 10px;
    --bg-color: var(--main-bg-color--rgb);
    padding: 4px 8px;
    background: rgba(var(--bg-color), var(--opacity, 0.6));
    font-weight: 700;
    border-radius: 10px;
    font-size: var(--text-size);
    white-space: nowrap;
    color: var(--text-color, #333);

    &.with-additional-data {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    /* Righe dei dati aggiuntivi impilate sotto la targa: angoli superiori piatti
       per attaccarsi alla riga precedente; angoli inferiori piatti tranne l'ultima. */
    &.additional-data-row {
        margin-top: 1px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;

        &.is-last {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
        }
    }
}

.font-awesome {
    font-family: 'Font Awesome Kit', 'FontAwesome', 'Font Awesome 6 Pro';
    color: #51b5c9 !important;
}
</style>
